export const aboutData = {
    title: "Who I am",
    description1: "My name's Phethani Cyril. I'm a frontend developer and UI/UX designer based in Johannesburg, South Africa.",
    description2: "I work as a freelancer. I spent my leisure hours designing posters, social covers and flyers. Right now I'm also trying a hand at machine learning and AI. I love to learn and explore new arenas.",
    image: 2
}